import { Box, Group, Text, Title } from '@mantine/core';
import { IconAlertCircle, IconRefresh } from '@tabler/icons-react';
import { KapaLogoWordmark } from 'components/common/kapa-logo-wordmark';
import { Button } from 'design-system/button/button';

export const ErrorFallback = () => {
  // Always hard-reload: the common cause of hitting this fallback is a
  // chunk-load failure after a deploy, where the in-memory module map still
  // points at stale asset hashes. A React-level resetError re-runs the same
  // failing dynamic import; only re-fetching index.html recovers.
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Box
      display="flex"
      h="100vh"
      p="24px"
      style={{ justifyContent: 'center', alignItems: 'center' }}
    >
      <Box
        display="flex"
        ta="center"
        maw="500px"
        w="100%"
        style={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '48px',
        }}
      >
        <KapaLogoWordmark
          className="text-foreground h-auto w-[150px]"
          aria-label="Kapa.ai logo"
        />
        <Box
          display="flex"
          style={{
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <Group gap="xs">
            <IconAlertCircle
              size={18}
              style={{ color: 'var(--color-foreground-secondary)' }}
            />
            <Title order={6} fw={500}>
              Something went wrong
            </Title>
          </Group>
          <Text size="sm" lh={1.5} c="var(--color-foreground-secondary)">
            We&apos;ve been notified and are working on a fix. Please try
            refreshing the page.
          </Text>
        </Box>
        <Button variant="elevated" onClick={handleRefresh}>
          <IconRefresh data-icon="inline-start" />
          Refresh Page
        </Button>
      </Box>
    </Box>
  );
};
